
import { SetStyles } from "../.././MyHelpers";
import { IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { SlideFactory } from "../Slider/SecondScreenHelp";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// namespace SlotGames2
// {
	export class GoldAndRum2 extends SlotGameType1_2
	{
		
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();

		////protected override freegameBonusFactory: FreegameBonusFactory2 = new GoldAndRumFreegame2BonusFactory();
		// public override TitleLoaded(resourceManager:ResourceManager)
		// {
		// 	super.TitleLoaded(resourceManager);

		// 	SetStyles(this.view.querySelector(".title"),
		// 	{
		// 		display:"flex",
		// 		justifyContent:"center",
		// 		margin:"26px",
		// 		//backgroundSize:"contain"


		// 	});
		// 	//this.titleSprite.Scale(1.5);
		// }

        protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
        {
        	super.PaytableLoaded(resourceManager);
        	SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
			{
				//HIDE BACKGROUND COLOR
				//backgroundColor:"rgba(0, 0, 0, 0.6)",
			});


        }
	}

	class GoldAndRumSecondScreenHelpFactory extends SlideFactory
	{
		public override CreateStyle():Partial<CSSStyleDeclaration>
		{
			let style :Partial<CSSStyleDeclaration> = 
			{
				color:"White"
			};
			return style;
		}
	}
	
// }
